import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './admin/context/AuthContext'
import ProtectedRoute from './admin/components/ProtectedRoute'

const Home          = lazy(() => import('./pages/Home'))
const SobreNosotros = lazy(() => import('./pages/SobreNosotros'))
const Blog          = lazy(() => import('./pages/Blog'))
const Documentos    = lazy(() => import('./pages/documentos'))
const Contacto      = lazy(() => import('./pages/contacto'))
const Tarifas       = lazy(() => import('./pages/Tarifas'))
const Rifas         = lazy(() => import('./pages/Rifas'))
const Politica      = lazy(() => import('./pages/Politica'))
const Recoleccion   = lazy(() => import('./pages/Recoleccion'))
const Barrido        = lazy(() => import('./pages/Barrido'))
const LimpiezaUrbana = lazy(() => import('./pages/LimpiezaUrbana'))
const AsesoriaCapacitaciones = lazy(() => import('./pages/AsesoriaCapacitaciones'))

const ProximamentePage = lazy(() => import('./admin/components/ProximamentePage'))
const AdminLayout = lazy(() => import('./admin/layout/AdminLayout'))
const Login = lazy(() => import('./admin/pages/auth/Login'))
const RecuperarPassword = lazy(() => import('./admin/pages/auth/RecuperarPassword'))
const RestablecerPassword = lazy(() => import('./admin/pages/auth/RestablecerPassword'))
const Dashboard = lazy(() => import('./admin/pages/dashboard/Dashboard'))
const PqrsLista = lazy(() => import('./admin/pages/pqrs/PqrsLista'))
const PqrsDetalle = lazy(() => import('./admin/pages/pqrs/PqrsDetalle'))
const PqrsCrear = lazy(() => import('./admin/pages/pqrs/PqrsCrear'))
const PqrsEditar = lazy(() => import('./admin/pages/pqrs/PqrsEditar'))
const SuiLista = lazy(() => import('./admin/pages/sui/SuiLista'))
const SuiDetalle = lazy(() => import('./admin/pages/sui/SuiDetalle'))
const SuiConsolidado = lazy(() => import('./admin/pages/sui/SuiConsolidado'))
const RifasLista = lazy(() => import('./admin/pages/rifas/RifasLista'))
const RifaForm = lazy(() => import('./admin/pages/rifas/RifaForm'))
const RifaDetalle = lazy(() => import('./admin/pages/rifas/RifaDetalle'))
const RifaBoletas = lazy(() => import('./admin/pages/rifas/RifaBoletas'))
const RifasParticipantes = lazy(() => import('./admin/pages/rifas/RifasParticipantes'))

function RouteFallback() {
  return <div style={{ position: 'fixed', inset: 0, background: '#fff' }} />
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/blog"           element={<Blog />} />
          <Route path="/documentos"     element={<Documentos />} />
          <Route path="/contacto"       element={<Contacto />} />
          <Route path="/tarifas"        element={<Tarifas />} />
          <Route path="/rifas"          element={<Rifas />} />
          <Route path="/politica"       element={<Politica />} />
          <Route path="/recoleccion"    element={<Recoleccion />} />
          <Route path="/barrido"        element={<Barrido />} />
          <Route path="/limpieza-urbana" element={<LimpiezaUrbana />} />
          <Route path="/asesoria-capacitaciones" element={<AsesoriaCapacitaciones />} />

          {/* Panel administrativo OCOBOS */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/recuperar" element={<RecuperarPassword />} />
          <Route path="/admin/restablecer-password" element={<RestablecerPassword />} />

          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            <Route path="pqrs" element={<ProtectedRoute permiso="pqrs.ver"><PqrsLista /></ProtectedRoute>} />
            <Route path="pqrs/nueva" element={<ProtectedRoute permiso="pqrs.gestionar"><PqrsCrear /></ProtectedRoute>} />
            <Route path="pqrs/:id" element={<ProtectedRoute permiso="pqrs.ver"><PqrsDetalle /></ProtectedRoute>} />
            <Route path="pqrs/:id/editar" element={<ProtectedRoute permiso="pqrs.gestionar"><PqrsEditar /></ProtectedRoute>} />

            <Route path="sui" element={<ProtectedRoute permiso="sui.ver"><SuiLista /></ProtectedRoute>} />
            <Route path="sui/consolidado" element={<ProtectedRoute permiso="sui.ver"><SuiConsolidado /></ProtectedRoute>} />
            <Route path="sui/:id" element={<ProtectedRoute permiso="sui.ver"><SuiDetalle /></ProtectedRoute>} />

            <Route path="rifas" element={<ProtectedRoute permiso="rifas.ver"><RifasLista /></ProtectedRoute>} />
            <Route path="rifas/nueva" element={<ProtectedRoute permiso="rifas.crear"><RifaForm /></ProtectedRoute>} />
            <Route path="rifas/participantes" element={<ProtectedRoute permiso="boletas.gestionar"><RifasParticipantes /></ProtectedRoute>} />
            <Route path="rifas/:id" element={<ProtectedRoute permiso="rifas.ver"><RifaDetalle /></ProtectedRoute>} />
            <Route path="rifas/:id/editar" element={<ProtectedRoute permiso="rifas.editar"><RifaForm /></ProtectedRoute>} />
            <Route path="rifas/:id/boletas" element={<ProtectedRoute permiso="rifas.ver"><RifaBoletas /></ProtectedRoute>} />
            <Route path="documentos" element={<ProtectedRoute permiso="documentos.gestionar"><ProximamentePage title="Documentos" /></ProtectedRoute>} />
            <Route path="tarifas" element={<ProtectedRoute permiso="tarifas.gestionar"><ProximamentePage title="Tarifas" /></ProtectedRoute>} />
            <Route path="conjuntos" element={<ProximamentePage title="Conjuntos" />} />
            <Route path="usuarios" element={<ProtectedRoute permiso="usuarios.gestionar"><ProximamentePage title="Usuarios" /></ProtectedRoute>} />
            <Route path="roles" element={<ProtectedRoute permiso="roles.gestionar"><ProximamentePage title="Roles" /></ProtectedRoute>} />
          </Route>
        </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  )
}
